import { ROUTES as R } from '@aibees/elephant/router';

export function useFindSearchItemPath(type: string) {
  if (type.includes('COMPANY')) return R.searchCompany;
  return R.searchPeople;
}
